<template>
  <div class="settle-detail big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>
        <span>费用明细</span>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="info">
          <div style="display: flex">
            <div class="infoitem">
              <span class="infotitle">医生姓名：</span>
              <span
                @click="showDocMsg(detail.doctor_id)"
                style="cursor: pointer"
                >{{ detail.doctor_name }}</span
              >
            </div>
            <div class="infoitem">
              <span class="infotitle">性别：</span>
              <span>{{ detail.sex == 1 ? "男" : "女" }}</span>
            </div>
            <div class="infoitem">
              <span class="infotitle">手机号：</span>
              <span>{{ detail.phone }}</span>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px">
            <div class="infoitem">
              <span class="infotitle">科室：</span>
              <span>{{ detail.department_name }}</span>
            </div>
            <div class="infoitem">
              <span class="infotitle">职称：</span>
              <span>{{ detail.title }}</span>
            </div>
            <div class="infoitem">
              <span class="infotitle">医院名称：</span>
              <span>{{ detail.hospital }}</span>
            </div>
          </div>
        </div>
        <div class="flex_between">
          <span style="font-size: 18px; font-weight: 600"
            >结算帐期：{{ detail.period }}</span
          >
          <el-button
            type="primary"
            @click="excelexport"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1037') : false
            "
            >导出明细</el-button
          >
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div class="num">{{ detail.sa_money }}</div>
              <div class="gray">税前金额总计</div>
            </div>
            <div class="priceitem" v-if="detail.status == 2">
              <div class="num">{{ detail.taxation_money }}</div>
              <div class="gray">扣缴税额总计</div>
            </div>
            <div class="priceitem" v-if="detail.status == 2">
              <div class="num">{{ detail.pay_money }}</div>
              <div class="gray">税后总金额</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ detail.consult_money }}</div>
              <div class="gray">问诊费总计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ platform_rewards }}</div>
              <div class="gray">平台活动奖励总计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ detail.recommend_goods_money }}</div>
              <div class="gray">商品推荐奖励</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ detail.drug_price }}</div>
              <div class="gray">诊后管理费总计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ detail.consulting_gold }}</div>
              <div class="gray">诊金总计</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ detail.forever_goods_money }}</div>
              <div class="gray">终身分佣奖励总计</div>
            </div>
          </div>
          <el-button
            type="primary"
            v-if="detail.status == 1"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('124') : false
            "
            @click="settlement"
            >结算入账</el-button
          >
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="item in tableData"
              :key="item.sa_id"
              :name="item.sa_id"
            >
              <template slot="title">
                <div class="detail-title">
                  <p>入账时间: {{ item.create_time | dateFormat }}</p>
                  <p>税前金额: {{ item.sa_money }}</p>
                  <p>扣缴税额: {{ item.taxation_money }}</p>
                  <p>税后金额: {{ item.pay_money }}</p>
                </div>
              </template>
              <!-- 内容 -->
              <el-table
                ref="multipleTable"
                :data="item.child"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column label="完成时间" prop="over_time">
                  <template slot-scope="scope">
                    {{ scope.row.over_time | dateFormat }}
                  </template>
                </el-table-column>

                <el-table-column label="费用类型" prop="type">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.type_str }}
                      <span v-if="scope.row.type == 5 || scope.row.type == 6"
                        >({{ scope.row.pro_name }})</span
                      >
                      <el-tag
                        v-if="scope.row.is_group_doctor"
                        type="danger"
                        size="mini"
                        >名医生</el-tag
                      >
                    </div>
                    <!-- <div v-if="scope.row.type == 1">问诊费用</div>
                    <div v-if="scope.row.type == 2">诊后管理费</div>
                    <div v-if="scope.row.type == 3">诊金</div>
                    <div v-if="scope.row.type == 4">平台奖励</div>
                    <div v-if="scope.row.type == 5">
                      项目推荐奖励({{ scope.row.pro_name }})
                    </div>
                    <div v-if="scope.row.type == 6">
                      商品推荐奖励({{ scope.row.pro_name }})
                    </div> -->
                  </template>
                </el-table-column>
                <el-table-column label="患者信息" prop="hospital_name">
                  <template slot-scope="scope">
                    <div v-if="scope.row.sex">
                      <div>{{ scope.row.user_name }}</div>
                      <div>
                        <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
                        <span style="margin-left: 10px">{{
                          scope.row.age
                        }}</span>
                      </div>
                      <div>{{ scope.row.phone }}</div>
                    </div>
                    <div v-else>匿名</div>
                  </template>
                </el-table-column>
                <el-table-column label="用户信息" prop="hospital_name">
                  <template slot-scope="scope">
                    <div>{{ scope.row.real_name }}</div>
                    <div>{{ scope.row.user_phone }}</div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="问诊单号/订单编号"
                  prop="order_sn"
                ></el-table-column>
                <el-table-column
                  label="问诊费用/订单金额"
                  prop="order_money"
                ></el-table-column>
                <el-table-column label="交易单号" prop="trade_no">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.trade_no == 0 ? "" : scope.row.trade_no }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="支付金额"
                  prop="pay_money"
                ></el-table-column>
                <el-table-column
                  label="单项金额"
                  prop="pay_sa_money"
                ></el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div style="margin-top: 24px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor_fee from "../../../api/doctor_fee";
import platform from "../../../api/platform";
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      detail: {},
      //账期是否结束（1是，0否）
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      activeNames: [],
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    platform_rewards() {
      return (
        ((parseFloat(this.detail.reward_money) +
          parseFloat(this.detail.product_money)) *
          100) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDetail() {
      let sa_id = this.$route.query.sa_id;
      doctor_fee.getFeeSettlementInfo({ sa_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.period = this.detail.period
            ? platform.timestampToDate(this.detail.period).slice(0, 7)
            : "";
        }
      });
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getItemList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getItemList();
    },
    //获取费用结算明细列表
    getItemList() {
      let data = {
        sa_id: this.$route.query.sa_id,
        settlement_status: this.$route.query.settlement_status,
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      doctor_fee.getFeeSettlementItemList(data).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.activeNames = data.list[0].sa_id;
          this.tableData = data.list;
          this.totalNum = data.total;
        }
      });
    },
    back() {
      history.back();
    },
    //结算入账
    settlement() {
      this.$confirm("将该月费用结算，并入账到医生账户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          doctor_fee
            .settlement({ sa_id: this.$route.query.sa_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("结算成功");
                history.back();
              }
            });
        })
        .catch();
    },
    //导出数据
    excelexport() {
      let sa_id = this.$route.query.sa_id;
      let loading = this.$loading();
      this.axios
        .post("platform/cost/exportFeeSettlementOrderList", { sa_id })
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
  created() {
    this.getDetail();
    this.getItemList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
}
.info {
  background-color: #f9f8ee;
  border: solid 1px #dad8ca;
  padding: 14px 0 14px 20px;
  text-align: left;
  margin-bottom: 30px;
  .infoitem {
    width: 300px;
    .infotitle {
      display: inline-block;
      width: 90px;
    }
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin: 12px 0;
  .price {
    display: flex;
    align-items: center;
    width: 100%;
    .priceitem {
      width: 14%;
      border-right: solid 1px #e1e3e9;
    }
    .priceitem:before {
      content: "";
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
.settle-detail {
  ::v-deep .el-collapse-item__header {
    height: 40px;
    background-color: #d7d7d7;
  }
  ::v-deep .el-collapse-item__content {
    padding: 0;
  }
  ::v-deep .el-collapse-item__wrap {
    border: none;
  }
  .detail-title {
    display: flex;
    p {
      font-size: 16px;
      padding: 0 20px;
    }
  }
}
</style>
